<template>
    <b-modal id="modal_form"
            size="lg"
            ref="modal_form"
            :title="modal_titulo"
            :ok-title="modal_botao"
            close-title="Fechar"
            cancel-title="Cancelar"
            v-model="showModal"
            >

            <b-row class="p-a-0" id="row">
                <b-col md="2">
                    <label>Código da Tabela de Frete: </label>
                    <span> {{this.dados.tabela_frete.cd}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tabela de Frete: </label>
                    <span> {{this.dados.tabela_frete.descr}}</span>
                </b-col>
                <b-col md="2">
                    <label>Data da aprovação: </label>
                    <span v-if="this.dados.dt_aprovacao != null"> {{this.dados.dt_aprovacao}}</span>
                    <span v-if="this.dados.dt_aprovacao == null"> Não constado</span>
                </b-col>
                <b-col md="2">
                    <label>Data do cancelamento: </label>
                    <span v-if="this.dados.dt_canc != null"> {{this.dados.dt_canc}}</span>
                    <span v-if="this.dados.dt_canc == null"> Não constado</span>
                </b-col> 
                <b-col md="2">
                    <label>Observações: </label>
                    <span v-if="this.dados.obs != null"> {{this.dados.obs}}</span>
                    <span v-if="this.dados.obs == null"> Não constado</span>
                </b-col>
                <b-col md="2">
                    <label>Status: </label>
                    <span class="badge badge-success" v-if="this.dados.status.valor==1"> {{ this.dados.status.descr }}</span>
                    <span class="badge badge-danger" v-if="this.dados.status.valor==2"> {{ this.dados.status.descr }}</span>
                </b-col>
            </b-row>
            <b-row class="p-a-0" style="margin-top:8px;" id="row">
                <b-col md="2">
                    <label>Tipo de Calculo: </label>
                    <span> {{this.dados.tabela_frete.tp_calculo}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo Receita/Despesa: </label>
                    <span> {{this.dados.tabela_frete.tp_receita_despesa}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo de Tabela: </label>
                    <span> {{this.dados.tabela_frete.tp_tabela}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo da Operação: </label>
                    <span> {{this.dados.tabela_frete_rota.tp_operacao}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo do Processo: </label>
                    <span> {{this.dados.tabela_frete_rota.tp_processo}}</span>
                </b-col>
            </b-row>
            <hr class="p-a-0 m-t m-b-0" style="border-top: 1px solid #98A4B8;">
            <div class="tbl-row p-a-0">
                <div class="tbl-cell tbl-cell-title">
                    <h5 id="title" class="m-a-0">Taxas</h5>
                </div>
            </div>

            <b-row class="p-a-0" id="row">
                <b-col md="2">
                    <label>Advalorem: </label>
                    <span> {{this.dados.taxa.ad_valorem}}</span>
                </b-col>
                <b-col md="2">
                    <label>Devolução: </label>
                    <span> {{this.dados.taxa.taxa_devolucao}}</span>
                </b-col>
                <b-col md="2">
                    <label>Gris: </label>
                    <span> {{this.dados.taxa.taxa_gris}}</span>
                </b-col>
                <b-col md="2">
                    <label>Pedagio: </label>
                    <span> {{this.dados.taxa.taxa_pedagio}}</span>
                </b-col>
                <b-col md="2">
                    <label>Reentrega: </label>
                    <span> {{this.dados.taxa.taxa_reentrega}}</span>
                </b-col>
            </b-row>
            
            <b-row class="p-a-0" id="row">
                <b-col md="2">
                    <label>TDA: </label>
                    <span> {{this.dados.taxa.taxa_tda}}</span>
                </b-col>
                <b-col md="2">
                    <label>TDE: </label>
                    <span> {{this.dados.taxa.taxa_tde}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor agendamento:</label>
                    <span> {{this.dados.taxa.vlr_agendamento}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor despacho: </label>
                    <span> {{this.dados.taxa.vlr_despacho}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor fixo TDA: </label>
                    <span> {{this.dados.taxa.vlr_fixo_tda}}</span>
                </b-col>
            </b-row>

            <b-row class="p-a-0" id="row">
                <b-col md="2">
                    <label>Valor fixo TDE: </label>
                    <span> {{this.dados.taxa.vlr_fixo_tde}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor minimo advalorem: </label>
                    <span> {{this.dados.taxa.vlr_minimo_advalorem}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor mionimo gris: </label>
                    <span> {{this.dados.taxa.vlr_minimo_gris}}</span>
                </b-col>
                <b-col md="2">
                    <label>Outros: </label>
                    <span> {{this.dados.taxa.vlr_outros}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor pedagio: </label>
                    <span> {{this.dados.taxa.vlr_pedagio}}</span>
                </b-col>
            </b-row>
            <b-row class="p-a-0" id="row">
                <b-col md="2">
                    <label>Valor sec cat: </label>
                    <span> {{this.dados.taxa.vlr_sec_cat}}</span>
                </b-col>
                <b-col md="2">
                    <label>Valor Tas: </label>
                    <span> {{this.dados.taxa.vlr_tas}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo taxa pedagio: </label>
                    <span> {{this.dados.taxa.tp_taxa_pedagio}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo taxa TDA: </label>
                    <span> {{this.dados.taxa.tp_taxa_tda}}</span>
                </b-col>
                <b-col md="2">
                    <label>Tipo taxa TDE: </label>
                    <span> {{this.dados.taxa.tp_taxa_tde}}</span>
                </b-col>
            </b-row>
            <div v-for=" calculo in this.dados.calculo">
            <hr class="p-a-0 m-t m-b-0" style="border-top: 1px solid #98A4B8;">

            <div class="tbl-row p-a-0">
                <div class="tbl-cell tbl-cell-title">
                    <h5 id="title" class="m-a-0">Calculo</h5>
                </div>
            </div>
                <b-row class="p-a-0" id="row">
                <b-col md="1">
                    <label>Excedente: </label>
                    <span> {{calculo.excedente}}</span>
                </b-col>
                <b-col md="1">
                    <label>Fator conv: </label>
                    <span> {{calculo.fator_conv}}</span>
                </b-col>
                <b-col md="1">
                    <label>Fixa: </label>
                    <span> {{calculo.fixa}}</span>
                </b-col>
                <b-col md="1">
                    <label>Valor: </label>
                    <span> {{calculo.vlr}}</span>
                </b-col>
                <b-col md="1">
                    <label>Valor Excedente: </label>
                    <span> {{calculo.vlr_exd}}</span>
                </b-col>
                <b-col md="1">
                    <label>Valor final: </label>
                    <span> {{calculo.vlr_fim}}</span>
                </b-col>
                <b-col md="1">
                    <label>Valor inicial: </label>
                    <span> {{calculo.vlr_ini}}</span>
                </b-col>
            </b-row>
            </div>
            <!-- <div v-if="this.dados.custo_extra != null && this.dados.tipo_carga != null"> -->
            <hr class="p-a-0 m-t m-b-0" style="border-top: 1px solid #98A4B8;">

            <div class="tbl-row p-a-0">
                <div class="tbl-cell tbl-cell-title">
                    <h5 id="title" class="m-a-0">Custo Extra</h5>
                </div>
            </div>
            <div v-for=" custo in this.dados.custo_extra">
                <b-row class="p-a-0" id="row">
                        <b-col md="2">
                            <label>Descrição: </label>
                            <span> {{custo.descr}}</span>
                        </b-col>
                        <b-col md="2">
                            <label>Taxa comissao: </label>
                            <span> {{custo.taxa_comissao}}</span>
                        </b-col>
                        <b-col md="2">
                            <label>Valor minimo: </label>
                            <span> {{custo.vlr_minimo}}</span>
                        </b-col>
                        <b-col md="2">
                            <label>Valor taxa: </label>
                            <span> {{custo.vlr_taxa}}</span>
                        </b-col>
                        <b-col md="2">
                            <label>Tipo trecho: </label>
                            <span> {{custo.tp_trecho}}</span>
                        </b-col>
                        <b-col md="2">
                            <label>Tipo trecho custo: </label>
                            <span> {{custo.tp_trecho_custo}}</span>
                        </b-col>
                </b-row>    
            </div>

            <hr class="p-a-0 m-t m-b-0" style="border-top: 1px solid #98A4B8;">

            <div class="tbl-row p-a-0">
                <div class="tbl-cell tbl-cell-title">
                    <h5 id="title" class="m-a-0">Carga</h5>
                </div>
            </div>
            <b-row class="p-a-0" id="row">
                 <b-col md="2" v-for="(carga, index) in this.dados.tipo_carga" :key="`tipo-carga-${index}`">
                    <label>Tipo da Carga: </label>
                    <span> {{carga.tp_carga}}</span>
                </b-col>

            </b-row>
           <hr class="p-a-0 m-t m-b-0" style="border-top: 1px solid #98A4B8;">
            <b-tabs>
                <b-tab title="Rota" active >
                    <b-row class="p-a-0" id="row" style="margin-top: 10px;">
                        <b-col md="3">
                            <label>Municipio de Origem: </label>
                            <span v-if="this.dados.tabela_frete_rota.municipio_origem != null"> {{this.dados.tabela_frete_rota.municipio_origem.nome}} - {{this.dados.tabela_frete_rota.municipio_origem.uf}}</span>
                            <span v-if="this.dados.tabela_frete_rota.municipio_origem == null"> Não constado</span>
                        </b-col>
                        <b-col md="3">
                            <label>Municipio de Destino: </label>
                            <span v-if="this.dados.tabela_frete_rota.municipio_destino != null"> {{this.dados.tabela_frete_rota.municipio_destino.nome}} - {{this.dados.tabela_frete_rota.municipio_destino.uf}}</span>
                            <span v-if="this.dados.tabela_frete_rota.municipio_destino == null"> Não constado</span>
                        </b-col>
                        <b-col md="3">
                            <label>Região de Origem: </label>
                            <span v-if="this.dados.tabela_frete_rota.regiao_origem != null"> {{this.dados.tabela_frete_rota.regiao_origem}}</span>
                            <span v-if="this.dados.tabela_frete_rota.regiao_origem == null"> Não constado</span>
                        </b-col>
                        <b-col md="3">
                            <label>Região de Destino: </label>
                            <span v-if="this.dados.tabela_frete_rota.regiao_destino != null"> {{this.dados.tabela_frete_rota.regiao_destino}} </span>
                            <span v-if="this.dados.tabela_frete_rota.regiao_destino == null"> Não constado</span>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Meio de trasnporte">
                    <div v-for="frota in this.dados.tipo_frota">
                        <b-row class="p-a-0" id="row" style="margin-top: 10px;">
                            <b-col md="2">
                                <label>Tipo de carroceria:  </label>
                                <span> {{frota.tp_carroceria}}</span>
                            </b-col>
                            <b-col md="2">
                                <label>Tipo rodado: </label>
                                <span> {{frota.tp_rodado}}</span>
                            </b-col>
                        </b-row>    
                    </div>
                </b-tab>
            </b-tabs>
    <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <b-btn @click="showModal=false" variant="secondary">
                    Fechar
                </b-btn>
            </div>
    </div>
</b-modal>
</template>
<script>

export default {
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        dados: {
            dt_aprovacao: '',
            dt_canc: '',
            obs: '',

            status:{
                descr: '',
                valor: '',
            },
            tabela_frete_rota:{
                municipio_origem:{
                    nome:'',
                    uf:''
                },
                municipio_destino:{
                    nome:'',
                    uf:''
                },
                regiao_origem: '',
                regiao_destino: '',

                tp_operacao: '',
                tp_processo: '',

            },

            tabela_frete:{
                cd: '',
                descr: '',
                tp_calculo: '',
                tp_receita_despesa: '',
                tp_tabela: ''
            },

            taxa:{
                ad_valorem:'',
                taxa_devolucao: '',
                taxa_gris: '',
                taxa_pedagio: '',
                taxa_reentrega: '',
                taxa_tda: '',
                taxa_tde: '',
                vlr_agendamento: '',
                vlr_despacho: '',
                vlr_fixo_tda: '',
                vlr_fixo_tde: '',
                vlr_minimo_advalorem: '',
                vlr_minimo_gris: '',
                vlr_outros: '',
                vlr_pedagio: '',
                vlr_sec_cat: '',
                vlr_tas: '',

                tp_taxa_pedagio: '',
                tp_taxa_tda: '',
                tp_taxa_tde: '',
            },

            calculo:[],
            custo_extra: [],
            tipo_carga:[],
            tipo_frota: [],

        },
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        errors_array: [],
        helpForm: new Form({
            statusRecord: [],
            params: [],
            tabfrerotvig_id: ''
        }),
        
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
   
},
mounted() {
        // this.getData();
      },
methods: {
    onView(tabfrerotvig_id) {
        // this.data = this.$parent.dados;
        // this.data.bcliente_id = this.$parent.dados.bcliente_id;
        this.dados.calculo =[]
        this.dados.custo_extra = []
        this.dados.tipo_carga =[]
         this.helpForm.tabfrerotvig_id = tabfrerotvig_id;

        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Tabela de Frete";
        this.$refs.modal_form.show();

        // this.dados.bcliente_id = this.$parent.dados.bcliente_id;

        
        

    },
    getData(tabfrerotvig_id)
    {

        this.loading = true;
        this.isDisabled = true;
        this.helpForm.get('/api/tabelafrete/consultavigencia/'+tabfrerotvig_id).then(response =>
        {               
            this.dados.dt_aprovacao = response.dt_aprovacao;
            this.dados.dt_canc = response.dt_canc;
            this.dados.obs = response.obs;

            //status
            this.dados.status.descr = response.status.descr;
            this.dados.status.valor = response.status.valor;

            //tabela_frete_rota.municipio_
            if(response.tabela_frete_rota.municipio_origem != null){
                this.dados.tabela_frete_rota.municipio_origem.nome = response.tabela_frete_rota.municipio_origem.nome;
                this.dados.tabela_frete_rota.municipio_origem.uf = response.tabela_frete_rota.municipio_origem.uf.cd;
            }

            if(response.tabela_frete_rota.municipio_destino != null){
                this.dados.tabela_frete_rota.municipio_destino.nome = response.tabela_frete_rota.municipio_destino.nome;
                this.dados.tabela_frete_rota.municipio_destino.uf = response.tabela_frete_rota.municipio_destino.uf.cd;
            }
            //tabela_frete_rota.rota.regiao_
            if(response.tabela_frete_rota.regiao_origem != null){
                this.dados.tabela_frete_rota.regiao_origem = response.tabela_frete_rota.regiao_origem.descr;
            }
             if(response.tabela_frete_rota.regiao_destino != null){
                this.dados.tabela_frete_rota.regiao_destino = response.tabela_frete_rota.regiao_destino.descr;
            }

            //tabela_frete_rota
            this.dados.tabela_frete_rota.tp_operacao = response.tabela_frete_rota.tp_operacao.descr;
            this.dados.tabela_frete_rota.tp_processo = response.tabela_frete_rota.tp_processo.descr;

            //tabela_frete_rota.tabela_frete
            this.dados.tabela_frete.cd = response.tabela_frete_rota.tabela_frete.cd;
            this.dados.tabela_frete.descr = response.tabela_frete_rota.tabela_frete.descr;
            this.dados.tabela_frete.tp_calculo = response.tabela_frete_rota.tabela_frete.tp_calculo.descr
            this.dados.tabela_frete.tp_receita_despesa = response.tabela_frete_rota.tabela_frete.tp_receita_despesa.descr;
            this.dados.tabela_frete.tp_tabela = response.tabela_frete_rota.tabela_frete.tp_tabela.descr;

            //tabela_frete_rota_vig_taxa
            this.dados.taxa.ad_valorem = response.tabela_frete_rota_vig_taxa.ad_valorem
            this.dados.taxa.taxa_devolucao = response.tabela_frete_rota_vig_taxa.taxa_devolucao
            this.dados.taxa.taxa_gris = response.tabela_frete_rota_vig_taxa.taxa_gris
            this.dados.taxa.taxa_pedagio = response.tabela_frete_rota_vig_taxa.taxa_pedagio
            this.dados.taxa.taxa_reentrega = response.tabela_frete_rota_vig_taxa.taxa_reentrega
            this.dados.taxa.taxa_tda = response.tabela_frete_rota_vig_taxa.taxa_tda
            this.dados.taxa.taxa_tde = response.tabela_frete_rota_vig_taxa.taxa_tde
            this.dados.taxa.vlr_agendamento = response.tabela_frete_rota_vig_taxa.vlr_agendamento
            this.dados.taxa.vlr_despacho = response.tabela_frete_rota_vig_taxa.vlr_despacho
            this.dados.taxa.vlr_fixo_tda = response.tabela_frete_rota_vig_taxa.vlr_fixo_tda
            this.dados.taxa.vlr_fixo_tde = response.tabela_frete_rota_vig_taxa.vlr_fixo_tde
            this.dados.taxa.vlr_minimo_advalorem = response.tabela_frete_rota_vig_taxa.vlr_minimo_advalorem
            this.dados.taxa.vlr_minimo_gris = response.tabela_frete_rota_vig_taxa.vlr_minimo_gris
            this.dados.taxa.vlr_outros = response.tabela_frete_rota_vig_taxa.vlr_outros
            this.dados.taxa.vlr_pedagio = response.tabela_frete_rota_vig_taxa.vlr_pedagio
            this.dados.taxa.vlr_sec_cat = response.tabela_frete_rota_vig_taxa.vlr_sec_cat
            this.dados.taxa.vlr_tas = response.tabela_frete_rota_vig_taxa.vlr_tas
            this.dados.taxa.tp_taxa_pedagio = response.tabela_frete_rota_vig_taxa.tp_taxa_pedagio.descr
            this.dados.taxa.tp_taxa_tda = response.tabela_frete_rota_vig_taxa.tp_taxa_tda.descr
            this.dados.taxa.tp_taxa_tde = response.tabela_frete_rota_vig_taxa.tp_taxa_tde.descr
            
            response.tabela_frete_rota_vig_calc.forEach((obj)=>{

                this.dados.calculo.push({
                    fator_conv : obj.fator_conv,
                    vlr : obj.vlr,
                    vlr_exd : obj.vlr_exd,
                    vlr_fim : obj.vlr_fim,
                    vlr_ini : obj.vlr_ini,
                    excedente : obj.excedente,
                    fixa : obj.fixa,
                })

                // this.dados.custo_extra.push({

                // }),

                // this.dados.tipo_carga.push({
                //     tp_carga: obj.tabela_frete_rota.tabela_frete_rota_carga.param_tipo_carga.descr,
                //     tp_carroceria: obj.tabela_frete_rota.tabela_frete_rota_meio_transp.param_tipo_carroceria.descr,
                //     tp_rodado: obj.tabela_frete_rota.tabela_frete_rota_meio_transp.param_tipo_rodado.descr,
                // })
            })
            if(response.tabela_frete_rota_vig_cus_ext.length > 0){
                response.tabela_frete_rota_vig_cus_ext.forEach((obj)=>{
                    this.dados.custo_extra.push({
                        descr: obj.custo.descr,
                        taxa_comissao: obj.taxa_comissao,
                        vlr_minimo: obj.vlr_minimo,
                        vlr_taxa: obj.vlr_taxa,
                        tp_trecho: obj.tp_trecho.descr,
                        tp_trecho_custo: obj.tp_trecho_custo.descr,
                    })
                })
            }
            response.tabela_frete_rota.tabela_frete_rota_carga.forEach((obj)=>{
                this.dados.tipo_carga.push({
                    tp_carga: obj.param_tipo_carga.descr,
                })
            })
            if(response.tabela_frete_rota.tabela_frete_rota_meio_transp.length > 0){
                response.tabela_frete_rota.tabela_frete_rota_meio_transp.forEach((obj)=>{
                    this.dados.tipo_frota.push({
                        tp_carroceria: obj.param_tipo_carroceria.descr,
                        tp_rodado: obj.param_tipo_rodado.descr,
                    })
                })
            }
            
            this.$refs.pedidotabelafretemodal.onView();
            
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                errors[property].forEach((obj) => {
                    this.errors_array.push({
                    erro: obj
                    });
                });
                }
            }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
<style>
#row label{
    font-weight: 600;
}

#title{
    font-size:1.5rem !important;
}
</style>